var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.493-.007q.642 0 1.068.427t.425 1.071q0 .632-.431 1.065l-9.403 9.424 9.403 9.423q.431.433.431 1.065 0 .643-.425 1.07t-1.068.428q-.63 0-1.061-.433l-9.39-9.435-9.39 9.435q-.432.433-1.062.433-.642 0-1.067-.427t-.426-1.071q0-.632.431-1.065l9.403-9.423L.528 2.556Q.097 2.124.097 1.491q0-.643.426-1.07T1.59-.008q.63 0 1.061.433l9.39 9.435L21.433.426q.432-.433 1.061-.433z"
  })));
};
export default SvgCross;